<template>
  <div>
    <section
      class="section-title-page container-fluid"
      style="background-image: url('/img/bg_tramite.jpg')"
    >
      <div class="container">
        <div class="wrapper">
          <h1>
            Eventos <small style="font-weight: 300"> a tu disposición</small>
          </h1>
          <span>
            Volver <i class="fa fa-angle-right mx-1"></i>
            <a href="/">Inicio</a>
          </span>
        </div>
      </div>
    </section>

    <section class="section-courses container-fluid">
      <div class="container p-0">
        <div class="col p-0 d-flex" v-if="ListaEventos.length > 0">
          <div v-for="(value, key) in ListaEventos" :key="key" class="col-md-6">
            <div class="box">
              <div class="img-course"
                @click="viewEvent(value)"
                :data-url="value.imagen"
                :style="{ 'background-image': 'url(' + value.imagen + ')' }">
                <i class="fa far fa-eye"></i>
              </div>
              <div class="text">
                <h3>{{ value.titulo }}</h3>
                <p v-html="value.descripcion"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="col p-0 d-flex" v-else>
          <div class="section-info w-100">
            <p class="m-0">
              <i class="fa-solid fa-ban mr-2"></i><strong>Lo sentimos</strong>,
              hoy no hay ningún evento registrado.
            </p>
          </div>
        </div>
      </div>
    </section>
    <div id="show-image" v-show="showEvent">
      <div class="base">
        <div class="image">
          <img :src="selectedEvent.imagen" alt="" />
          <span>{{ selectedEvent.titulo }}</span>
        </div>
        <div class="close" @click="closeEvent()">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Eventos",
  computed: {
    ...mapState(["empresa"]),
  },
  created() {},
  mounted() {
    this.getEventos();
  },
  data() {
    return {
      ListaEventos: [],
      showEvent: false,
      selectedEvent: {},
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getEventos() {
      this.setLoading(true);
      this.$http.get("ws_event/list_events").then((res) => {
        this.ListaEventos = res.data.Eventos;
        this.setLoading(false);
      });
    },
    viewEvent(Event) {
      this.selectedEvent = Event;
      this.showEvent = true;
    },
    closeEvent() {
      this.showEvent = false;
    },
  },
};
</script>